'use client';

import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InputField, InputFieldProps } from '../input-field/input-field.tsx';

export const PasswordField: FC<InputFieldProps> = ({ ...inputFieldProps }) => {
  const { t } = useTranslation(['forms']);
  const [showPassword, setShowPassword] = useState(false);
  return (
    <InputField
      type={!showPassword ? 'password' : 'text'}
      iconName={!showPassword ? 'eye-off' : 'eye'}
      iconLabel={t(
        !showPassword ? 'forms:login.showPassword' : 'forms:login.hidePassword',
      )}
      iconAction={() => setShowPassword(!showPassword)}
      {...inputFieldProps}
    />
  );
};
